import { render, staticRenderFns } from "./JwJiaocaiOrderList.vue?vue&type=template&id=f85583de"
import script from "./JwJiaocaiOrderList.vue?vue&type=script&lang=js"
export * from "./JwJiaocaiOrderList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports